<template>
  <q-item-section :avatar="avatar" :side="side" :top="top">
    <slot />
  </q-item-section>
</template>

<script>
export default {
  name: 'ItemSection',
  props: {
    avatar: {
      type: Boolean,
      default: false,
    },
    side: {
      type: Boolean,
      default: false,
    },
    top: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped></style>
